export default {
  Token: {
    token: '代幣',
    trending: '行情',
    graduated: '已經發射',
    quickBuy: '快速買入',
    filterRisk: '過濾風險',
    select: '選擇',
    liquidity: '流動性',
    marketCap: '市值',
    holder: '持有',
    price: '價格',
    all: '全部',
    devHold: 'DEV 未清倉',
    devSellAll: 'DEV 清倉',
    devBunt: 'DEV 燒幣',
    action: '操作',
    holding: '持倉',
    buy: '買',
    chg: '漲跌幅',
    balance: '餘額',
    '7D': '7天',
    '30D': '30天',
    deposit: '充值',
    amount: '數量',
    vol: '交易額',
    mc: '市值',
    watchList: '關注',
    newCreations: '新創建',
    aboutToGraduate: '即將打滿',
    status: '狀態',
    migrating: '遷移中',
    signals: '信號',
    treasures: '榜單',
  },
  Base: {
    nodata: '沒有數據...',
    depositFund: '充值資產',
    depositFundText: '掃描二維碼或者複製地址以充值資產',
    depositFundTextTips: '（僅接受{{chain}}上的資產）',
    withdrawFund: '提取資產',
    withdraw: '提取',
    available: '可用：',
    all: '全部',
    enterAddress: '輸入地址',
    confirmWithdraw: '確認提取',
    withdrawTips: '請確認是否轉賬。錯誤的地址將無法恢復。',
    sendTips: '您將把 <0>{{amount}}</0> <0>{{symbol}}</0> 發送到以下地址',
    share: '分享',
    enterAmount: '請輸入數量',
    pleLogin: '請先登錄',
    cancel: '取消',
    copyAddress: '複製地址',
    login: '登錄',
    copySuccessful: '複製成功',
    noPermission: '没有權限',
    invalidAddressTips: '請輸入EVM（Solana）地址',
  },
  Address: {
    '30DPnL': '30天盈虧',
    '7DPnL': '7天盈虧',
    last7DPnl: '最近7天盈虧',
    last30DPnl: '最近30天盈虧',
    share: '分享',
    profit: '利潤',
    distribution: '盈利分佈',
    winRate: '勝率',
    solBalance: 'SOL 餘額',
    totalPnL: '總利潤',
    unrealizedProfit: '未實現利潤',
    pnL: '利潤',
    '7dToastCost': '7天總花費',
    '7dTokenAvgCost': '7天平均花費',
    '7dTokenRealizedAvgCost': '7天代幣平均利潤',
    '7dBuyTokens': '7天代幣買入數',
    '30dToastCost': '30天總花費',
    '30dTokenAvgCost': '30天平均花費',
    '30dTokenRealizedAvgCost': '30天代幣平均利潤',
    '30dBuyTokens': '30天代幣買入數',
    recentPnl: '最近收益',
    holdings: '持倉',
    activity: '活動',
    history: '記錄',
    '7dRealizedProfit': '7天已實現收益',
    '30dRealizedProfit': '30天已實現收益',
    token: '代幣',
    totalProfit: '總收益',
    tokenLastActive: '代幣/最後活動',
    unrealized: '未實現利潤',
    realizedProfit: '已實現利潤',
    balance: '餘額',
    position: '倉位',
    bought: '買入',
    sold: '賣出',
    avg: '平均',
    '30DTxs': '30天交易數',
    hideSmallAssets: '隱藏小額資產',
    hideSellOut: '隱藏全部賣出',
    type: '類型',
    total: '總額',
    amount: '數量',
    price: '價格',
    time: '時間',
    deposit: '充值',
    withdraw: '提取',
    from: '從',
    to: '到',
  },
  Header: {
    revokeDelegate: '撤銷委託',
    approveDelegate: '授權委託',
    logout: '登出',
    exportWallet: '導出錢包',
    referral: '邀請',
    watchList: '關注',
    language: '語言',
    search: '搜索',
    searchHistory: '搜索歷史',
    enterContractToken: '輸入合約/代幣',
    dayTrending: '24小時行情',
    darkMode: '黑夜模式',
    advanced: '高級設置',
    deposit: '充值',
    withdraw: '提取',
  },
  SmartTag: {
    all: '全部',
    bargainHunter: '抄底大師',
    topEscapeMaster: '逃頂大師',
    heavyPositionsMaster: '重倉少出手',
    pumpfunHunter: '內盤高盈利',
    diamondHand: '鑽石手',
    alwaysWrong: '反指',
    newAddress: '新地址',
  },
  Tabbar: {
    token: '代幣',
    smart: '聰明錢',
    trade: '交易',
    account: '用戶',
    signal: '信號',
    watchList: '關注',
  },
  Trade: {
    balanceD: '餘額：',
    slippageD: '滑點：',
    priorityFeeD: '優先費：',
    setting: '設置',
    auto: '自動',
    mevProtection: 'MEV保護',
    TakeProfitAndStopLoss: '止盈止損',
    insufficientBalanceRecharge: '餘額不足請充值',
    amountCannotBeZero: '數量不能為0',
    enterAmount: '請輸入數量',
    insufficientBalance: '餘額不足，請充值',
    insufficientBalanceNoGas: '餘額不足以支Gas費用',
    buy: '買',
    sell: '賣',
    market: '市價',
    limit: '限價',
    reservedBalanceTooFew: 'SOL餘額不足以支付Gas費用',
    quantity: '數量',
    value: '數值',
    allTimeGains: '所有時間收穫',
    currentPNL: '當前利潤',
    position: '收益',
    myOrder: '我的訂單',
    activity: '活動',
    unrealized: '未實現利潤',
    realizedProfit: '已實現利潤',
    BoughtAndAvg: '已購買/平均價',
    totalProfit: '總利潤',
    balance: '餘額',
    type: '類型',
    price: '價格',
    total: '總額',
    amount: '數量',
    maker: '交易者',
    time: '時間',
    slippageTips: '滑點不能大於30%',
    priorityFeeTips: '優先費不能大於0.2 SOL',
    never: '從不',
    '10min': '10 分鐘',
    '1hour': '1 小時',
    '1day': '1 天',
    '3day': '3 天',
    '7day': '7 天',
    '30day': '30 天',
    cancel: '取消',
    createWhen: '創建快照',
    targetPrice: '觸發價',
    status: '狀態',
    condition: '觸發條件',
    priceIncrease: '價格上漲',
    priceDrop: '價格下跌',
    limitPriceNotZero: '掛單價格不能為0',
    limitPriceNotEmpty: '掛單價格不能為空',
    limitAmountNotGtBalance: '掛單數量不能大於餘額',
    totalPriceNotLt10: '掛單總價不能小於10USDT',
    priceInUSD: 'USD 本位',
    expiry: '有效期',
    dropChgNoGte100: '下跌幅度不能大於等於100%',
    active: '運行',
    success: '成功',
    expiration: '過期時間',
    canceled: '已取消',
    insufficientFunds: '資金不足',
    buyIn: '買入',
    sellOut: '賣出',
    mcap: '市值',
    liq: '流動性',
    '24hVol': '24H交易額',
    holders: '持有者',
    holding: '持倉',
    orders: '訂單',
    chart: '圖表',
    info: '信息',
    marketInfo: '市場信息',
    liquidity: '流動性',
    marketCap: '市值',
    createdAt: '創建時間',
    '24hVolume': '24小時交易額',
    volumes: '交易額',
    makers: '交易數',
    buys: '買入數',
    sells: '賣出數',
    buyVol: '買入額',
    sellVol: '賣出額',
    buyers: '買入數',
    sellers: '賣出數',
    login: '登錄',
    edit: '編輯',
    slippageLowTips: '滑點過低可能導致交易失敗, 建議設置在 0.1% ~ 80% 之間.',
    slippageZeroTips: '滑點不應為 0%, 建議設置在 0.1% ~ 80% 之間.',
    slippageExceedTips: '滑點不應超過 80%, 建議設置在 0.1% ~ 80% 之間.',
    solPriorityFeeLowTips: '優先級費過低可能導致交易執行過慢, 建議設置在 0.012 ~ 2 SOL 之間.',
    solPriorityFeeExceedTips: '優先級費不應超過 2 SOL, 建議設置在 0.012 ~ 2 SOL 之間.',
    bscGasFeeLowTips: 'Gas 費過低可能導緻交易執行過慢, 建議設置在 1 ~ 20 Gwei 之間',
    bscGasFeeExceedTips: 'Gas 費過高可能導緻高額費用, 建議設置在 1 ~ 20 Gwei 之間',
    advancedSetting: '高級設置',
    slippage: '滑點',
    priorityFee: '優先費',
    confirm: '確認',
    AntiMEV: '防MEV',
    close: '關閉',
    percent: '百分比',
    sellAll: '清倉',
    authorize: '授權',
    gasFee: 'Gas費',
  },
  Smart: {
    smartMoney: '聰明錢',
    notification: '通知',
    users: '用戶',
    quickBuy: '快速買入',
    '7d': '7天',
    '30d': '30天',
    '7dWinRate': '7天勝率',
    '7dRoi': '7天收益率',
    '7dPnL': '7天收益',
    '30dWinRate': '30天勝率',
    '30dRoi': '30天收益率',
    '30dPnL': '30天收益',
  },
  Follow: {
    follow: '關注',
    smartMoney: '聰明錢',
    tokens: '代幣',
    vol: '交易額',
    mc: '市值',
    chg: '漲跌幅',
    price: '價格',
  },
  Referral: {
    referralText: '賺取你邀請人交易手續費的 <0>30%<0/> 以及他們邀請人交易手續費的 <0>5%</0>',
    invitationLink: '邀請連結',
    availableRewards: '可提取獎勵',
    claimedRewards: '已提取獎勵',
    totalReferrals: '邀請人數',
    points: '積分',
    myReferrals: '我的推薦',
    withdrawTips: '返傭大於 $50 時才能提現',
    pointTips: '交易 $1 獲得 100 積分, 積分未來可以用於兌換平颱更多增值服務或潛在的空投.',
    wallet: '資金賬戶',
    volume: '交易額',
    rewards: '獎勵',
    referralOverview: '推薦總覽',
    withdraw: '提取',
    ambassadorProgram: '大使計劃',
    ambassadorProgramTips: '申請大使計劃, 賺取更高返傭',
    apply: '申請',
  },
  Account: {
    deposit: '存款',
    withdraw: '取款',
    holding: '持倉',
    activity: '活動',
    history: '歷史',
    type: '類型',
    time: '時間',
    token: '代幣',
    value: '金額',
    price: '價格',
    all: '全部',
    buy: '買入',
    sell: '賣出',
    unrealizedProfit: '未實現利潤',
    balance: '餘額',
    to: '到',
    from: '從',
    maker: '交易者',
    address: '地址',
  },
  Signal: {
    price: '價格',
    mc: '市值',
    liquidity: '流動性',
    holders: '持有者',
    alert: '提醒',
    now: '現在',
    safe: '安全',
    noMint: '鑄造丟棄',
    blackList: '黑名單',
    burnt: '燒池子',
    totalProfit: '總盈利',
    bought: '買入金額',
    time: '時間',
    alertMaxChg: '第一次提醒後的最大增幅為<0>{{symbol}}</0><0>{{value}}</0>',
    wallet: '錢包',
    setting: '設置',
    mergeSignals: '合併信號',
    mevProtection: 'MEV 保護',
    slippage: '滑點',
    auto: '自動',
    priorityFee: '優先費',
    amountQuickBuy: '快速購買金額（{{symbol}}）',
    percentQuickSell: '快速出售百分比',
    cancel: '取消',
    confirm: '確認',
    top10: 'Top 10',
    alertTips: '第 <0>{{count}}</0> 次提醒在 <0>{{time}}</0>',
    token: '代幣',
    alertTime: '提醒次数',
    maxIncrease: '最大漲幅',
    notBalance: '餘額不足',
    tutorial: '輔導',
    howItWorks: '如何工作',
    signalFilter: ' 訊號過濾',
    signalAlertTimes: ' 訊號提醒次數',
    reset: ' 重置',
    apply: ' 應用',
    pushTimesTips: '該 meme 的第 <0>{{ordinal}}</0> 次提醒',
    search: '搜索',
    risk: '風險',
    openSource: ' 合約開源',
    honeypot: ' 蜜罐',
    renounced: ' 合約棄權',
    gasFee: 'Gas费',
  },
};
